import { makeRequest, Service, identify } from 'utils/http';
import { CreateWorkspaceRequest } from 'trace-backend-sdk';

export async function createWorkspaceAPI(workspace: CreateWorkspaceRequest) {
  return makeRequest(Service.createWorkspace(workspace, await identify()));
}
